
<!-- eslint-disable -->
<template>
<div :class="{p2s2c1_rule_selected: selectedRuleUid === ruleUid}" class="p2s2c1_rule" @click="selectRule">
<div>{{ruleName}}</div>
<div class="p2s2c1_icons">
<span v-if="selectedRuleUid === ruleUid" class="p2s2c1_update_icon" @click.prevent="editRule"></span>
<span v-if="selectedRuleUid === ruleUid" class="p2s2c1_delete_icon" @click.prevent="deleteRule"></span>
</div>
</div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'p2s2c1RuleEntry',
  props: ['ruleName','ruleUid','selectedRuleUid'],

  methods: {    
    editRule: function(event) {
        this.$emit('event-edit-rule',this.ruleUid);
      },
    deleteRule: function(event) {
        this.$emit('event-delete-rule',this.ruleUid);
      },
    selectRule: function(event) {
      this.$emit('event-select-rule',this.ruleUid);
    }
  }

}

</script>


// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2/p2s2c1RuleEntry.vue